import {
  Box,
  HStack,
  IconButton,
  useDisclosure,
  VStack,
  Flex,
  Heading,
  Select,
  Link,
  Image,
} from "@chakra-ui/react";
import { ReactNode, useEffect, useState } from "react";
import SidebarRender from "../Sidebar";
import { GiHamburgerMenu } from "react-icons/gi";
import { useMediaQuery } from "react-responsive";
import HeaderMenu from "../Header/HeaderMenu";
import NotificationBell from "../NotificationBell";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import SearchableSelect from "../SearchableSelect";
import { CompanyFormData } from "../../pages/Configurations/tabs/types";
import { getCompanies } from "../../services/companyService";
import { companyOptions, useCompany } from "../../contexts/CompanyContext";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [clients, setClients] = useState<CompanyFormData[]>([]);
  const [loadingCompany, setLoadingCompany] = useState<boolean>(true);
  const {
    currentEmulation,
    setCurrentEmulation,
    currentCompany,
    setCurrentCompany,
  } = useCompany();

  const auth = useAuthUser<any>();

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    const getClients = async () => {
      const response = await getCompanies(false, currentCompany);
      if (response) setClients(response);
      setLoadingCompany(false);
    };
    getClients();
  }, [currentCompany]);

  return (
    <HStack
      w="100vw"
      h="100vh"
      p="0"
      m="0"
      justifyContent={"flex-start"}
      align="flex-start"
      spacing={0}
    >
      <SidebarRender
        isOpen={isOpen}
        onClose={onClose}
        isMobile={isMobile as boolean}
      />
      <VStack
        zIndex="1"
        w="100%"
        maxW="100%"
        overflow="hidden"
        borderLeft={"2px solid rgb(229, 229, 229)"}
        h="100%"
      >
        {isMobile ? (
          <Flex
            justifyContent="space-between"
            p="12px"
            w="100%"
            alignItems="center"
          >
            <Link href="/" mb={{ base: "0px", md: "32px" }}>
              <Image
                src={
                  process.env.REACT_APP_LOGO === "syntra"
                    ? "syntraLogo.png"
                    : "grupoCvfLogo.png"
                }
                height="40px"
              />
            </Link>
            <Flex alignItems="center" gap="8px">
            <NotificationBell />
            <IconButton
              alignSelf="flex-end"
              aria-label="menu"
              icon={<GiHamburgerMenu size="20" />}
              onClick={onOpen}
              mb={{ base: "0px", md: "20px" }}
            />
            </Flex>
          </Flex>
        ) : (
          <Flex
            p="20px"
            w="100%"
            justifyContent="space-between"
            gap={{ base: "32px", md: "64px" }}
          >
            <Box>
              {auth?.position > 1 && (
                <Flex gap="24px">
                  {(auth?.company === "Geral" ||
                    auth?.company == "CVF Distribuidora") &&
                    !loadingCompany && (
                      <Box>
                        <Heading size="sm" mb="8px">
                          Empresa
                        </Heading>
                        <Select
                          value={currentCompany}
                          onChange={(e) =>
                            setCurrentCompany(parseFloat(e.target.value))
                          }
                        >
                          {companyOptions
                            .filter(
                              (c) =>
                                auth?.company === "Geral" ||
                                (c.label !== "CVF Logística" &&
                                  c.label !== "Todas"),
                            )
                            .map((c) => (
                              <option key={c.value} value={c.value}>
                                {c.label}
                              </option>
                            ))}
                        </Select>
                      </Box>
                    )}
                  <Box>
                    <Heading size="sm" mb="8px">
                      Emular cliente
                    </Heading>
                    {clients && (
                      <SearchableSelect
                        width="15vw"
                        defaultSelectValue={{
                          value: currentEmulation,
                          label: clients.find((c) => c.id == currentEmulation)
                            ?.name,
                          subLabel: "",
                        }}
                        backgroundColor="white"
                        options={[
                          { value: null, label: "Todos", subLabel: "" },
                          ...clients
                            .filter(
                              (c) =>
                                auth.admin ||
                                auth.clients.length === 0 ||
                                auth.clients.some(
                                  (cc: any) => cc.companyId === c.id,
                                ),
                            )
                            .map((c) => ({
                              value: c.id,
                              label: c.name,
                              subLabel: c.cnpj,
                            })),
                        ]}
                        name="clientId"
                        setValue={(value) => {
                          setCurrentEmulation(value);
                        }}
                      />
                    )}
                  </Box>
                </Flex>
              )}
            </Box>
            <HeaderMenu />
          </Flex>
        )}
        <Box
          h="100%"
          w="100%"
          backgroundColor="var(--main-bg-color)"
          overflow="auto"
        >
          {children}
        </Box>
      </VStack>
    </HStack>
  );
};

export default Layout;
